<template>
  <div class="form-group form-group--select" :class="getClass()">
    <link rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">

    <div class="row">
      <div :class="`col-sm-${component.size}`">
        <label>{{ component.label }}
          <span class="required" v-if="isRequired()">*</span>
        </label>
        <v-select
          ref="selectapi"
          :id="component.key"
          v-model="component.data.currentValue"
          class="style-chooser"
          @search="fetchOptions"
          @search:focus="fetchOptions"
          @open="visibilityChanged(true)"
          @close="visibilityChanged(false)"
          placeholder="Selecione uma opção"
          :multiple="component.isMultiselect===true"
          @focus="focusHandler()"
          @search:blur="blurHandler()"
          v-validate="setRules()"
          :name="component.key"
          :filterable="!component.autocomplete"
          :disabled="disabledHandler()"
          :data-vv-name="component.key"
          :options="resultData"
          :getOptionLabel="option => option && Array.isArray(option.label) ? option.label[0] : option && option.label ? option.label : option">
          <template v-if="component.data.multline" slot="option" slot-scope="option">
            <span v-for="(label, index) in option.label" :key="index">
              <strong v-if="index === 0">{{ label }}</strong>
              <br v-if="index !== 0" />
              <small v-if="index !== 0">{{ label }}</small>
            </span>
          </template>
          <template slot="no-options">
            <span v-if="!error">Nenhum registro encontrado.</span>
            <span v-else-if="errorMensagem">{{ errorMensagem }}</span>
            <span v-else>Falha ao buscar opções<button type="button" class="btn-link" @click="buscar()">clique aqui</button>para tentar novamente.</span>
          </template>
          <template #spinner="{ loading }">
            <div v-if="loading" style="border-left-color: rgba(88,151,251,0.71)" class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg>
            </div>
          </template>
        </v-select>
      </div>
      <span class="help-block help-block--bottom" v-if="errors.has(component.key)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" width="14">
            <g transform="translate(-252 -635)">
              <rect class="cls-1" width="14" height="14" transform="translate(252 635)" />
              <path class="cls-2"
                    d="M7.4,9.8H8.6V11H7.4ZM7.4,5H8.6V8.6H7.4Zm.594-3A6,6,0,1,0,14,8,6,6,0,0,0,7.994,2ZM8,12.8A4.8,4.8,0,1,1,12.8,8,4.8,4.8,0,0,1,8,12.8Z"
                    transform="translate(251 634)" />
            </g>
          </svg>
          {{ (errors.first(component.key)) }}</span>
      <span class="help-block help-block--bottom"
            v-if="!errors.has(component.key) && component.description">{{ component.description }}</span>
    </div>
  </div>
</template>
<script>
// Mixins
// https://br.vuejs.org/v2/guide/mixins.html
import component from '@/mixins/component'
import api from '../../api/form'
import { mapState } from 'vuex'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import formTransformer from '@/services/formTransformer'

export default {
  mixins: [component],
  props: ['component'],
  inject: ['$validator'],
  name: 'component-select-api',
  components: {
    vSelect
  },
  data () {
    return {
      isFocus: false,
      isValue: false,
      isErrors: false,
      values: [],
      focos: false,
      data: null,
      selection: false,
      clientKeyStorage: '',
      obj: {},
      objBody: {},
      resultData: [],
      valueInput: '',
      error: false,
      errorMensagem: ''
    }
  },
  computed: {
    ...mapState({
      components: state => state.formJson.components,
      variables: state => state.config.variables,
      json: state => state.config.json,
      clientKey: state => state.config.clientKey
    })
  },
  methods: {
    selectValue (v) {
      this.component.data.currentValue = {
        label: v[this.component.data.propertyLabel],
        value: v[this.component.data.propertyValue]
      }
      this.valueInput = v[this.component.data.propertyLabel]
      this.verificarFocus()
    },
    selectOp (val) {
      this.component.data.currentValue = [val]
    },
    verificarFocus () {
      this.focos = true
    },
    selectedValueFieldDisabled () {
      // Opção do campo select desabilitado, de colocar o item como selecionado, somente se não for um array e estiver retornando de uma api
      this.components.forEach((el, i) => {
        if(el.type === "select-api") {
          if(el.rule.disabled === true) {
            api.getApiLimit(
              this.component.data.url,
              this.obj, this.objBody,
              this.clientKey ? this.clientKey : this.clientKeyStorage,
              this.component.data.securityGroup ? this.component.data.securityGroup : this.component.eventsData.securityGroup
            ).then((res) => {
              if (res.data.data) { 
                if (el.data.propertyLabel === undefined || el.data.propertyValue === undefined) {
                  this.$validator.errors.add({
                    field: `${this.component.key}`,
                    msg: 'Propriedade value incorreta!'
                  })
                } else {
                  if (!Array.isArray(res.data.data)) {
                    this.resultData = []
                    el.data.currentValue = res.data.data.label
                    const item = {
                      label: [res.data.data.label],
                      value: res.data.data.value
                    }      
                    this.resultData.push(item)
                  }
                }
              }
            })
            .catch((error) => {
              if (error) this.error = true
              if (error.response) {
                resp = error.response
              }
            })
          }
        }
      })
    },
    async fetchOptions (search, loading) {
      if (search === undefined) {
        this.$refs.selectapi.toggleLoading(true)
        await this.buscar(false).catch(() => this.$refs.selectapi.toggleLoading(false))
        this.$refs.selectapi.toggleLoading(false)
      } else {
        this.valueInput = search
        loading(true)
        await this.buscar(search)
        loading(false)
      }
    },
    async buscar (input) {
      let filtrosApi = []
      let hasCompFilter = false
      this.component.data.requestBody.forEach((filtros) => {
        if (filtros.typeCondition === 'component') {
          hasCompFilter = true
          this.components.forEach((comp) => {
            if (comp.type === 'group') {
              comp.components.forEach((compFilho) => {
                if (compFilho.key === filtros.value) {
                  filtrosApi.push({ tag: filtros.tag, value: compFilho.data.currentValue })
                }
              })
            }
            if (comp.key === filtros.value) {
              filtrosApi.push({ tag: filtros.tag, value: comp.data.currentValue })
            }
          })
        }
        if (filtros.typeCondition === 'custom') {
          filtrosApi.push({ tag: filtros.tag, value: filtros.value })
        }
      })

      filtrosApi.map((el) => {
        this.objBody[el.tag] = el.value
      })

      this.obj = {}

      if (!input && this.component.autocomplete === true) {
        this.obj.limit = 30
      }

      if (input && this.component.autocomplete === true) {
        this.obj.search = input
      }

      this.component.data.headers.map((el) => {
        this.obj[el.header] = el.value
      })

      if (this.component.autocomplete === true || this.resultData.length === 0 || hasCompFilter) {
        let lines = []
        if (this.component.data.multline === true) {
          this.component.data.lines.forEach((el, i) => {
            lines.push(el.name)
          })
        }

        let resp = await api.getApiLimit(
          this.component.data.url,
          this.obj, this.objBody,
          this.clientKey ? this.clientKey : this.clientKeyStorage,
          this.component.data.securityGroup ? this.component.data.securityGroup : this.component.eventsData.securityGroup
        ).catch((error) => {
          if (error) this.error = true
          if (error.response) {
            resp = error.response
          }
        })

        if (!resp.data.data) {
          this.error = true
          this.errorMensagem = resp.data.mensagem
        } else if (resp.data.data.length === 0) {
          this.resultData = []
        }

        if (resp.data.data) {
          resp.data.data.forEach((propValue) => {
            if (propValue[this.component.data.propertyLabel] === undefined || propValue[this.component.data.propertyValue] === undefined) {
              this.$validator.errors.add({
                field: `${this.component.key}`,
                msg: 'Propriedade value incorreta!'
              })
            } else {
              this.resultData = []
              if (resp.data.data.length !== 0) {
                resp.data.data.forEach((valor) => {
                  if (this.resultData.length === 0) {
                    const item = {
                      label: [valor[this.component.data.propertyLabel]],
                      value: valor[this.component.data.propertyValue]
                    }
                    if (this.component.data.multline === true) {
                      lines.forEach((line) => {
                        item.label.push(valor[line])
                      })
                    }
                    this.resultData.push(item)
                  } else {
                    const found = this.resultData.find((element) => element.label === valor[this.component.data.propertyLabel])
                    if (!found) {
                      const item = {
                        label: [valor[this.component.data.propertyLabel]],
                        value: valor[this.component.data.propertyValue]
                      }
                      if (this.component.data.multline === true) {
                        lines.forEach((line) => {
                          item.label.push(valor[line])
                        })
                      }
                      this.resultData.push(item)
                    }
                  }
                })
              }
            }
          })
        }
      }
    },
    visibilityChanged (visible) {
      const padding = visible ? 320 : null
      formTransformer.changeBottomPaddingPx(padding)
    }
  },
  mounted () {
  },
  async created () {
    this.clientKeyStorage = await localStorage.getItem('clientKey')
    this.setValue()
    this.selectedValueFieldDisabled()
  },
  watch: {
    'component.data.currentValue': function (after, before) {
      if (after && !Array.isArray(after)) {
        this.component.data.currentValue = [after]
      }
    }
  }
}
</script>
